import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import DieuXeService from "services/Asset/DieuXe/Index";

const unwrapResponseData = (response) => {
  const body = response?.data;
  return body?.data?.data ?? body?.data ?? body;
};

export const create = createAsyncThunk(
  "dieuXe/create",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DieuXeService.Create(data);
      if (response.data) {
        if (onSuccess) onSuccess(response.data);
      }
      return unwrapResponseData(response);
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const groupPhieuToDieuChuyenXe = createAsyncThunk(
  "dieuXe/groupPhieuToDieuChuyenXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;

      const response = await DieuXeService.GroupPhieuToDieuChuyenXe(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const createChuyenXe = createAsyncThunk(
  "dieuXe/createChuyenXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await DieuXeService.CreateChuyenXe(payload);
      const responseData = unwrapResponseData(response);

      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const UpdateChuyenXeStatus = createAsyncThunk(
  "dieuXe/UpdateChuyenXeStatus",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;

      const response = await DieuXeService.UpdateChuyenXeStatus(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const deleteDieuChuyenXe = createAsyncThunk(
  "dieuXe/deleteDieuChuyenXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;

      const response = await DieuXeService.DeleteDieuChuyenXe(id);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const updateDieuChuyenXe = createAsyncThunk(
  "dieuXe/updateDieuChuyenXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;

      const response = await DieuXeService.UpdateDieuChuyenXe(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const searchDieuChuyenXe = createAsyncThunk(
  "dieuXe/searchDieuChuyenXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, loadMore } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;
      delete payload.loadMore;

      const response = await DieuXeService.SearchDieuChuyenXe(payload);
      const responseData = response?.data
      if (onSuccess) onSuccess(responseData);
      return { responseData, loadMore: Boolean(loadMore) };
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const update = createAsyncThunk(
  "dieuXe/update",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DieuXeService.Update(data);
      if (response.data) {
        if (onSuccess) onSuccess(response.data);
      }
      return unwrapResponseData(response);
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getAll = createAsyncThunk(
  "dieuXe/getAll",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DieuXeService.GetAll(data);
      return unwrapResponseData(response);
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getAllDrivers = createAsyncThunk(
  "dieuXe/getAllDrivers",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;

      const response = await DieuXeService.GetAllDrivers(payload);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const deletePhieu = createAsyncThunk(
  "dieuXe/deletePhieu",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DieuXeService.DeletePhieu(id);
      if (response.data) {
        if (onSuccess) onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getById = createAsyncThunk(
  "dieuXe/getById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DieuXeService.GetByid(id);
      if (response.data) {
        if (onSuccess) onSuccess(response.data);
      }
      return unwrapResponseData(response);
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getDetailChuyenXe = createAsyncThunk(
  "dieuXe/getDetailChuyenXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data || {};
      const payload = cloneDeep(data || {});
      delete payload.onSuccess;

      const response = await DieuXeService.GetDetailDieuChuyenXe(id);
      const responseData = unwrapResponseData(response);
      if (onSuccess) onSuccess(responseData);
      return responseData;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);
export const CheckIsDriver = createAsyncThunk(
  "dieuXe/CheckIsDriver",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DieuXeService.CheckIsDriver();
      return unwrapResponseData(response);
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);
const initialState = {
  loading: false,
  isDriver: false,
  dieuXeDetail: {},
  danhSachphieuDieuXe: [],

  chuyenXeDetailLoading: false,
  chuyenXeDetail: {},

  dieuChuyenXeLoading: false,
  dieuChuyenXeItems: [],
  dieuChuyenXeHasNextPage: true,
  dieuChuyenXeTotalCount: 0,
  dieuChuyenXeSkip: 0,
  dieuChuyenXeTake: 20,

  groupPhieuToDieuChuyenXeLoading: false,

  selectExistingTripMode: false,
  selectedPhieuIdsForTrip: [],

  // Driver related state
  driversLoading: false,
  drivers: [],
  driversTotalCount: 0,
  driversSkip: 0,
  driversTake: 20,
  driversHasNextPage: true,
};

const dieuXeSlice = createSlice({
  name: "dieuXe",
  initialState,
  reducers: {
    resetdanhSachTaiSanDeNghiHuy: (state, action) => {
      state.danhSachTaiSanDeNghiHuy = [];
    },
    resetdieuXeDetail: (state, action) => {
      state.dieuXeDetail = {};
    },
    resetChuyenXeDetail: (state) => {
      state.chuyenXeDetail = {};
    },

    setSelectedPhieuIdsForTrip: (state, action) => {
      state.selectedPhieuIdsForTrip = action.payload || [];
    },
    clearSelectedPhieuIdsForTrip: (state) => {
      state.selectedPhieuIdsForTrip = [];
    },
    setSelectExistingTripMode: (state, action) => {
      state.selectExistingTripMode = Boolean(action.payload);
    },
    startSelectExistingTrip: (state, action) => {
      state.selectExistingTripMode = true;
      state.selectedPhieuIdsForTrip = action.payload || [];
    },
    cancelSelectExistingTrip: (state) => {
      state.selectExistingTripMode = false;
      state.selectedPhieuIdsForTrip = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(create.pending, (state) => {
        state.loading = true;
      })
      .addCase(create.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(create.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.loading = false;
        const dieuXe = action.payload?.dieuXe || [];
        const lotrinh = action.payload?.lotrinh || [];

        const lotrinhByPhieuId = (lotrinh || []).reduce((acc, item) => {
          const key = item?.idPhieuDieuXe;
          if (!key) return acc;
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});

        state.danhSachphieuDieuXe = (dieuXe || []).map((x) => ({
          ...x,
          loTrinh: lotrinhByPhieuId[x.id] || [],
        }));
      })
      .addCase(getAll.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deletePhieu.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePhieu.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePhieu.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getById.fulfilled, (state, action) => {
        state.loading = false;
        state.dieuXeDetail = action.payload;
      })
      .addCase(getById.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDetailChuyenXe.pending, (state) => {
        state.chuyenXeDetailLoading = true;
      })
      .addCase(getDetailChuyenXe.fulfilled, (state, action) => {
        state.chuyenXeDetailLoading = false;
        state.chuyenXeDetail = action.payload;
      })
      .addCase(getDetailChuyenXe.rejected, (state) => {
        state.chuyenXeDetailLoading = false;
      })

      .addCase(update.pending, (state) => {
        state.loading = true;
      })
      .addCase(update.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(update.rejected, (state) => {
        state.loading = false;
      })

      .addCase(searchDieuChuyenXe.pending, (state) => {
        state.dieuChuyenXeLoading = true;
      })
      .addCase(searchDieuChuyenXe.fulfilled, (state, action) => {
        state.dieuChuyenXeLoading = false;
        const { responseData, loadMore } = action.payload || {};
        const responseListData = responseData?.data || []
        const items = responseListData || [] // Handle both array and object with items
        // Backend decides if there's next page, not frontend
        state.dieuChuyenXeHasNextPage = Boolean(responseData?.hasNextPage);
        state.dieuChuyenXeItems = loadMore
          ? [...(state.dieuChuyenXeItems || []), ...(items || [])]
          : items || [];

        state.dieuChuyenXeTotalCount = responseData?.totalCount || 0;
        state.dieuChuyenXeSkip = responseData?.skip ?? 0;
        state.dieuChuyenXeTake = responseData?.take ?? state.dieuChuyenXeTake;
      })
      .addCase(searchDieuChuyenXe.rejected, (state) => {
        state.dieuChuyenXeLoading = false;
      })
      .addCase(updateDieuChuyenXe.pending, (state) => {
        state.dieuChuyenXeLoading = true;
      })
      .addCase(updateDieuChuyenXe.fulfilled, (state) => {
        state.dieuChuyenXeLoading = false;
      })
      .addCase(updateDieuChuyenXe.rejected, (state) => {
        state.dieuChuyenXeLoading = false;
      })
      .addCase(deleteDieuChuyenXe.pending, (state) => {
        state.dieuChuyenXeLoading = true;
      })
      .addCase(deleteDieuChuyenXe.fulfilled, (state) => {
        state.dieuChuyenXeLoading = false;
      })
      .addCase(deleteDieuChuyenXe.rejected, (state) => {
        state.dieuChuyenXeLoading = false;
      })
      .addCase(UpdateChuyenXeStatus.pending, (state) => {
        state.dieuChuyenXeLoading = true;
      })
      .addCase(UpdateChuyenXeStatus.fulfilled, (state) => {
        state.dieuChuyenXeLoading = false;
      })
      .addCase(UpdateChuyenXeStatus.rejected, (state) => {
        state.dieuChuyenXeLoading = false;
      });

    builder
      .addCase(groupPhieuToDieuChuyenXe.pending, (state) => {
        state.groupPhieuToDieuChuyenXeLoading = true;
      })
      .addCase(groupPhieuToDieuChuyenXe.fulfilled, (state) => {
        state.groupPhieuToDieuChuyenXeLoading = false;
      })
      .addCase(groupPhieuToDieuChuyenXe.rejected, (state) => {
        state.groupPhieuToDieuChuyenXeLoading = false;
      })
      .addCase(createChuyenXe.pending, (state) => {
        state.loading = true;
      })
      .addCase(createChuyenXe.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createChuyenXe.rejected, (state) => {
        state.loading = false;
      }).addCase(CheckIsDriver.pending, (state) => {
        state.isDriver = true;
      })
      .addCase(CheckIsDriver.fulfilled, (state, action) => {
        state.isDriver = action.payload || false;
      })
      .addCase(CheckIsDriver.rejected, (state) => {
        state.isDriver = false;
      });

    // Drivers reducers
    builder
      .addCase(getAllDrivers.pending, (state) => {
        state.driversLoading = true;
      })
      .addCase(getAllDrivers.fulfilled, (state, action) => {
        state.driversLoading = false;
        state.drivers = action.payload?.data || [];
        state.driversTotalCount = action.payload?.totalCount || 0;
        state.driversSkip = action.payload?.skip || 0;
        state.driversTake = action.payload?.take || 20;
        state.driversHasNextPage = action.payload?.hasNextPage || false;
      })
      .addCase(getAllDrivers.rejected, (state) => {
        state.driversLoading = false;
      });
  },
});

export const {
  resetdanhSachTaiSanDeNghiHuy,
  resetdieuXeDetail,
  resetChuyenXeDetail,
  setSelectedPhieuIdsForTrip,
  clearSelectedPhieuIdsForTrip,
  setSelectExistingTripMode,
  startSelectExistingTrip,
  cancelSelectExistingTrip,
} = dieuXeSlice.actions;

export default dieuXeSlice.reducer;
